export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold">{title}</h1>
      {subtitle && <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p>}
    </div>
    {action}
  </div>
);
